import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-new-consent-version-disclaimer',
  imports: [
    NgClass
  ],
  templateUrl: './new-consent-version-disclaimer.component.html'
})
export class NewConsentVersionDisclaimerComponent {
  @Input() brand: VehicleBrand;

  constructor(
    private router: Router
  ) {}

  openWizard() {
    this.router.navigate([`/consentViaWizard/${this.brand.name.toLowerCase()}`]);
  }
}
